import { createContext, useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('plantshop_cart')) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('plantshop_cart', JSON.stringify(items));
  }, [items]);

  const addToCart = (product, quantity = 1) => {
    setItems(prev => {
      const existing = prev.find(i => i._id === product._id);
      if (existing) {
        const newQty = existing.quantity + quantity;
        if (newQty > product.stock) {
          toast.error(`Only ${product.stock} units available`);
          return prev;
        }
        toast.success('Cart updated');
        return prev.map(i => i._id === product._id ? { ...i, quantity: newQty } : i);
      }
      toast.success(`${product.name} added to cart 🛒`);
      return [...prev, { ...product, quantity }];
    });
  };

  const removeFromCart = (productId) => {
    setItems(prev => prev.filter(i => i._id !== productId));
    toast.success('Item removed from cart');
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity < 1) return removeFromCart(productId);
    setItems(prev => prev.map(i => i._id === productId ? { ...i, quantity } : i));
  };

  const clearCart = () => setItems([]);

  const itemCount = items.reduce((acc, i) => acc + i.quantity, 0);

  const subtotal = items.reduce((acc, i) => {
    const price = i.discountPrice || i.price;
    return acc + price * i.quantity;
  }, 0);

  const shippingCost = subtotal >= 999 ? 0 : 99;
  const taxAmount = Math.round(subtotal * 0.18);
  const total = subtotal + shippingCost + taxAmount;

  return (
    <CartContext.Provider value={{
      items, addToCart, removeFromCart, updateQuantity, clearCart,
      itemCount, subtotal, shippingCost, taxAmount, total,
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
